import ChooseSpheronApp from './choose-spheron-app';

export default ChooseSpheronApp;
